/**
 * External Documentation Links Configuration
 *
 * Centralized configuration for all external documentation and resource links.
 * Update the base URL here to change the documentation hosting location.
 */

// Base URL for E6Data documentation
// Change this to update all documentation links if docs are moved to a different URL
const DOCUMENTATION_BASE_URL = 'https://docs.e6data.com';

export const EXTERNAL_LINKS = {
  /**
   * Main documentation pages
   */
  DOCUMENTATION: `${DOCUMENTATION_BASE_URL}/product-documentation`,
  PRIVACY_POLICY: `${DOCUMENTATION_BASE_URL}/product-documentation/privacy-policy`,

  /**
   * Additional documentation sections (for future use)
   */
  API_DOCS: `${DOCUMENTATION_BASE_URL}/api-documentation`,
  RELEASE_NOTES: `${DOCUMENTATION_BASE_URL}/release-notes`,
  HELP_CENTER: `${DOCUMENTATION_BASE_URL}/help-center`,
  GETTING_STARTED: `${DOCUMENTATION_BASE_URL}/getting-started`,
} as const;

/**
 * Helper function to open external links in a new tab
 */
export const openExternalLink = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
